import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
// import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import { Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import "./index.scss";

import NoDataFound from "../../../../../components/ui/NoDataFound";
import Button from "../../../../../components/ui/Button";
import ContentBox from "../../../../../components/ui/ContentBox";
import Pagination from "../../../../../components/ui/Pagination";
import PaginationArrow from "../../../../../components/ui/PaginationArrow";
import CustomToolTip from "../../../../../components/ui/Tooltip";
import RadioButton from "../../../../../components/ui/RadioButton";
import { toaster } from "../../../../../components/ui/Toaster";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";

import ListFilter from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/ConcerningExposure/ListFilter";
import EndpointsFilter from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/ConcerningExposure/EndpointFilter";

import { plusIcon, minusIcon, searchIcon, viewMoreIcon, infoBlueIcon } from "../../../../../utils/icons";
import { getloggedInUserType } from "../../../../../utils/util";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import apiEndpoints from "../../../../../apiEndpoints";

import { useSelector, useDispatch } from 'react-redux';
import { getJsSecretsList, getJsSecretsEndpoints, updateListData, resetUpdateListDataResponse, resetJsSecretsList } from "../../../../../store/actions/scanInfoAction";

const JSSecrets = () => {

    const jsSecretsListResponse = useSelector((state) => state.scanInfo?.jsSecretsList);
    const jsSecretsEndpointsListResponse = useSelector((state) => state.scanInfo?.jsSecretsEndpointsList);
    const updateStatusListResponse = useSelector((state) => state?.scanInfo?.updateStatusList);

    const viewMoreWrapperRef = useRef(null);

    const updateUrl = apiEndpoints.scanInfo.exposureManagemnet.concerningExposure.jsSecrets

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerListFetch,
        setTriggerListFetch,
        setContextCurrentPage
    } = useScanInfoContext();

    const[activeContent, setActiveContent] = useState("affectedEndpoints");
    // const [selectedViewMore, setSelectedViewMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedjsSecretsList, setSelectedJsSecretsList] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isEndpointLoading, setIsEndpointLoading] = useState(false);
    const [showExtractDataModal, setShowExtractDataModal] = useState(false);
    const [extractedData, setExtractedData] = useState("");
    const [scanNotFound, setScanNotFound] = useState(false);
    const [listCurrentPage, setListCurrentPage] = useState(1);
    const [jsSecretsList, setJsSecretsList] = useState(null);
    // modal state
    const [showActionModal, setShowActionModal] = useState(false);
    const [modalType, setModalType] = useState("")
    const [selectedData, setSelectedData] = useState("");
    const [modalLoading, setModalLoading] = useState(false);
    const [showViewMore, setShowViewMore] = useState(false);
    const [selectedValid, setSelectedValid] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [selectedSeverity, setSelectedSeverity] = useState("");

    //list search state
    const [jsSecreteSearch, setJsSecreteSearch] = useState("");
    const [updatedJsSecreteSearchValue, setUpdatedJsSecreteSearchValue] = useState("");

    //affected endpoint search state
    const [endpointSearch, setEndpointSearch] = useState("");
    const [endpointsQuery, setEndpointsQuery] = useState("");
    const [endpointSearchFocused, setEndpointSearchFocused] = useState(false);

    //selected list filter
    const [listFilterValue, setListFilterValue] = useState({});

    //endpoint filter
    const [endpointFiltersValue, setEndpointFiltersValue] = useState({})

    
    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const handlePageChange = (newPage) => {
        setListCurrentPage(newPage);
        setContextCurrentPage(newPage);
        setTriggerListFetch(true);
    };

    const showContent = (data) => {  
        if(activeContent === data) {
            setActiveContent("")
        } else {
            setActiveContent(data)
            if(data === "affectedEndpoints") {
                fetchAffectedEndPoints()
            }
        }
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && endpointSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setCurrentPage(1)
        setEndpointsQuery(endpointSearch)
    }

    const listFilterApply = (data) => {
        setListCurrentPage(1);
        setListFilterValue(data);
        setContextCurrentPage(1);
        setTriggerListFetch(true);
    }

    const isAnyFilterActive = Object.values(listFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {
        setListCurrentPage(1);
        setListFilterValue({});
        setContextCurrentPage(1);
        setTriggerListFetch(true);
    }

    const endPointFilterApply = (data) => {
        setCurrentPage(1)
        setEndpointFiltersValue(data)
    }

    const isAnyEndpointFilterActive = Object.values(endpointFiltersValue).some(value => Boolean(value));

    const resetEndpointFilterValue = () => {
        setCurrentPage(1)
        setEndpointFiltersValue({})
    }

    const fetchAffectedEndPoints = useCallback(()=>{
        setIsEndpointLoading(true)
        const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}&domain=${selectedjsSecretsList?.domain}&scan_id=${selectedjsSecretsList?.scan_id}&result_id=${selectedjsSecretsList?.id}`;
        const queryParams = endpointsQuery ? `&query=${endpointsQuery}` : "";
        const newFindings = endpointFiltersValue?.newFindings?.value && endpointFiltersValue?.newFindings?.value !== "all" ? `&new_record=${endpointFiltersValue?.newFindings?.value === "yes" ? true : false}` : "";
        const falsePositive = endpointFiltersValue?.falsePositive?.value && endpointFiltersValue?.falsePositive?.value !== "all" ? `&false_positive=${endpointFiltersValue?.falsePositive?.value === "yes" ? true : false}` : "";
        const status = endpointFiltersValue?.status?.value && endpointFiltersValue?.status?.value !== "all" ? `&status=${endpointFiltersValue?.status?.value}` : "";
        const severity = endpointFiltersValue?.severity?.value && endpointFiltersValue?.severity?.value !== "all" ? `&severity=${endpointFiltersValue?.severity?.value}` : "";
        const url = `${baseUrl}${queryParams}${newFindings}${falsePositive}${status}${severity}`
        if(selectedjsSecretsList?.id) {
            dispatch(getJsSecretsEndpoints(url))
        }        
    },[currentPage, currentPageSize, selectedjsSecretsList, endpointsQuery, endpointFiltersValue, dispatch])
    
    const requestSearch = useMemo(() => debounce((searchTerm) => {
        setUpdatedJsSecreteSearchValue(searchTerm)
    }, 500), []);

    const fetchJsSecretsList = useCallback(()=>{
        const baseUrl = `&page=${listCurrentPage}&page_size=10`;
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const queryParams = updatedJsSecreteSearchValue ? `&query=${updatedJsSecreteSearchValue}` : "";
        const newFindings = listFilterValue?.newFindings?.value && listFilterValue?.newFindings?.value !== "all" ? `&new_record=${listFilterValue?.newFindings?.value === "yes" ? true : false}` : "";
        const status = listFilterValue?.status?.value && listFilterValue?.status?.value !== "all" ? `&status=${listFilterValue?.status?.value}` : "";
        const severity = listFilterValue?.severity?.value && listFilterValue?.severity?.value !== "all" ? `&severity=${listFilterValue?.severity?.value}` : "";
        const url = `${baseUrl}${params}${queryParams}${newFindings}${status}${severity}`
        setIsLoading(true);
        setScanNotFound(false);
        dispatch(getJsSecretsList(url))
    },[dispatch, domainId, scanId, organizationId, listCurrentPage, updatedJsSecreteSearchValue, listFilterValue])

    const confirmDelete = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            result_id: selectedData?.id
        }
        dispatch(updateListData(updateUrl.jsSecretsDelete(), obj))
    }

    const saveUpdate = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            endpoint_id: selectedData?.id,
            false_positive: selectedValid === "valid" ? false : true
        }
        dispatch(updateListData(updateUrl.jsSecretsValidate(), obj))
    }

    const updateStatus = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            endpoint_id: selectedData?.id,
            status: selectedStatus
        }
        dispatch(updateListData(updateUrl.jsSecretsStatus(), obj))
    }

    const updateSeverity = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            endpoint_id: selectedData?.id,
            severity: selectedSeverity
        }
        dispatch(updateListData(updateUrl.jsSecretsSeverity(), obj))
    }

    const updateRetest = () => {
        setModalLoading(true)
        let obj = {
            domain: selectedData?.domain,
            scan_id: selectedData?.scan_id,
            endpoint_id: selectedData?.id
        }
        if(modalType === "start") {
            dispatch(updateListData(updateUrl.jsSecretsStart(), obj))
        } else {
            dispatch(updateListData(updateUrl.jsSecretsStop(), obj))
        }
    }

    useEffect(()=>{        
        if (selectedjsSecretsList) {
            fetchAffectedEndPoints();
        }
    },[currentPage, selectedjsSecretsList, fetchAffectedEndPoints])

    useEffect(() => {
        if (triggerListFetch) {
            fetchJsSecretsList();
            setTriggerListFetch(false);
        }
    }, [triggerListFetch, currentPage, setTriggerListFetch, fetchJsSecretsList]);

    useEffect(() => {
        setListCurrentPage(1); // reset to first page
        setContextCurrentPage(1);
        setTriggerListFetch(true); // trigger fetch
    }, [setTriggerListFetch, setContextCurrentPage, updatedJsSecreteSearchValue]);

    useEffect(()=>{
        if(jsSecretsListResponse !== null) {
            setJsSecretsList(jsSecretsListResponse)
            if(jsSecretsListResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            if(jsSecretsListResponse?.results?.length > 0) {                
                setSelectedJsSecretsList(jsSecretsListResponse?.results[0])
            }
            dispatch(resetJsSecretsList())
            setIsLoading(false);
        }
    },[jsSecretsListResponse, dispatch])

    useEffect(()=>{
        if(jsSecretsEndpointsListResponse !== null) {
            setIsEndpointLoading(false);
        }
    },[jsSecretsEndpointsListResponse])

    useEffect(()=>{
        if(updateStatusListResponse !== null) {
            setShowActionModal(false)
            setModalLoading(false)
            if(updateStatusListResponse?.status === "success") {
                toaster.addToast(updateStatusListResponse?.description,"success")
                fetchAffectedEndPoints()
            } else {
                toaster.addToast(updateStatusListResponse?.description,"error")
            }
            dispatch(resetUpdateListDataResponse())
        }
    },[updateStatusListResponse, fetchAffectedEndPoints, dispatch])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (viewMoreWrapperRef.current && !viewMoreWrapperRef.current.contains(event.target)) {
                if(showViewMore){
                    setShowViewMore(false)
                }
            }        
        }
    },[showViewMore])

    return (
        <>
            <div className="js-secrets-main-content">
                <Row>
                    <Col lg={3}>
                        <div className="bg-white-with-shadow subdomain-list-container h-100">
                            <div className="list-heading px-3 pt-3 d-flex justify-content-between align-items-center">
                                <h1>JS Secrets List</h1>
                                {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                                <ListFilter listFilterApply={listFilterApply} listFilterValue={listFilterValue} currentPage={"default"} />                                
                            </div>
                            <div className="search-container px-3 position-relative">
                                <span className="position-absolute search-icon">{searchIcon()}</span>
                                <input type="text" 
                                    placeholder="Search" 
                                    className="w-100 rounded input" 
                                    value={jsSecreteSearch} 
                                    onChange={(e)=>{
                                        setJsSecreteSearch(e.target.value)
                                        requestSearch(e.target.value)
                                        setListCurrentPage(1)
                                        setContextCurrentPage(1);
                                        setTriggerListFetch(true);
                                    }}
                                />
                            </div>

                            <div className="list-main-container js-secrets-list">
                                { !isLoading && scanNotFound &&
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <NoDataFound noDataText={jsSecretsList?.description}/>
                                    </motion.div>
                                }
                                {
                                    isLoading && !scanNotFound ?
                                    <SkeletonLoader type={"line"} count={5} currentPage={"jsSecrets"} />
                                    :
                                    (
                                        jsSecretsList?.results?.length > 0 &&
                                        jsSecretsList?.results?.map((data, index)=>{
                                            return (
                                                <motion.div
                                                    key={index}
                                                    initial={{ opacity: 0, y: 20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                                >
                                                    <div className={`sub-domain-list py-2 px-3 ${selectedjsSecretsList?.id === data?.id ? "active" : ""}`} key={index} onClick={()=>{
                                                        resetEndpointFilterValue()
                                                        setSelectedJsSecretsList(data)
                                                        }}>
                                                        <div className="d-flex align-items-center gap-2 mb-2">
                                                            <p className="sub-domain-heading">{data?.name}</p>
                                                            {data.new_record && <span className="new-subdomain">New</span>}
                                                        </div>                                                
                                                        <p className="sub-domain-name">{data?.domain}</p>
                                                        <div className="status-container d-flex mb-2">
                                                            <p className="severity">Severity: &nbsp;  
                                                                {data?.severity === "critical" && <span className="critical">{data?.severity}</span>}
                                                                {data?.severity === "high" && <span className="high">{data?.severity}</span>}
                                                                {data?.severity === "medium" && <span className="medium">{data?.severity}</span>}
                                                                {data?.severity === "low" && <span className="low">{data?.severity}</span>}
                                                                {data?.severity === "informational" && <span className="informational">Info</span>}
                                                                {data?.severity === "unknown" && <span className="unknown">Unknown</span>}
                                                            </p>
                                                            <div className="status-container">
                                                                <p className="affected-endpoint">Affected Endpoints: <span>{data?.endpoints?.total}</span></p>                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                </motion.div>
                                            )
                                        })
                                    )
                                }
                                { !isLoading && jsSecretsList?.results?.length > 0 &&
                                    <PaginationArrow 
                                        totalCount={jsSecretsList?.meta?.total_results}
                                        currentPage={listCurrentPage}
                                        onPageChange={handlePageChange}
                                    />                                  
                                }
                                { !isLoading && jsSecretsList?.results?.length === 0 &&
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <NoDataFound noDataText={"JS Secrets Not Found"}/>
                                    </motion.div>
                                }
                            </div>
                        </div>
                    </Col>
                    <Col lg={9}>
                        <div className="main-content bg-white-with-shadow p-2 h-100">
                            {
                                !isLoading && scanNotFound ?
                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <NoDataFound noDataText={jsSecretsList?.description}/>
                                </motion.div>
                                :
                                (
                                    !isLoading && jsSecretsList?.results?.length === 0 ?
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4 }}
                                        >
                                            <NoDataFound noDataText={"No Data Found"}/>
                                        </motion.div>
                                    :
                                    <>
                                        <div className="record-container-content p-2">
                                            <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{showContent("jsSecretsSummary")}}>
                                                <h2 className="heading">JS Secrets Summary</h2>
                                                {activeContent === "jsSecretsSummary" ? minusIcon() : plusIcon()}
                                            </div>
                                            {
                                                isLoading ?
                                                    <SkeletonLoader type={"line"} count={5} currentPage={"sensitiveExpo"} />
                                                :
                                                <>
                                                    {activeContent === "jsSecretsSummary" && <div className="js-secrete-summary mt-3">
                                                        <motion.div
                                                            initial={{ opacity: 0, y: 20 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ duration: 0.4 }}
                                                        >
                                                            <Row>
                                                                <Col lg={6} className="mb-3">
                                                                    <ContentBox label={"Name"} value={selectedjsSecretsList?.name}/>
                                                                </Col>
                                                                <Col lg={6} className="mb-3">
                                                                    <ContentBox label={"Description"} value={selectedjsSecretsList?.description}/>
                                                                </Col>
                                                                <Col lg={6} className="mb-3">
                                                                    <div className="content-box-container p-3 rounded h-100">
                                                                        <h4 className="label">Severity</h4>
                                                                        <p className="severity">{selectedjsSecretsList?.severity}</p>
                                                                    </div>
                                                                </Col>
                                                                <Col lg={6} className="mb-3">
                                                                    <ContentBox label={"Remediation"} value={selectedjsSecretsList?.remediation}/>
                                                                </Col>
                                                                <Col lg={6} className="mb-3">
                                                                    <div className="content-box-container p-3 rounded h-100">
                                                                        <h4 className="label">Reference</h4>
                                                                        { selectedjsSecretsList !== "" && selectedjsSecretsList?.reference.length > 0  ?
                                                                            selectedjsSecretsList?.reference.map((data, index) => {
                                                                                return (
                                                                                    <p className="value" key={index}>{data}</p>
                                                                                )
                                                                            })
                                                                            :
                                                                            "-"                                                            
                                                                        }
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </motion.div>
                                                    </div> }
                                                </>
                                            }                               
                                        </div>
                                        <div className="record-container-content p-2 mt-3">
                                            <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{showContent("affectedEndpoints")}}>
                                                <h2 className="heading">Affected Endpoints</h2>
                                                {activeContent === "affectedEndpoints" ? minusIcon() : plusIcon()}
                                            </div>
                                            {activeContent === "affectedEndpoints" && <div className="affected-endpoint-container">
                                                <div className="git-leaks-main-content">
                                                    <div className="search-header-container d-flex align-items-center gap-3 my-3">
                                                        <div className="search-container position-relative">
                                                            <div className="d-flex gap-3" onKeyDown={handleSearchKeyDown}>
                                                                <span className="position-absolute">{searchIcon()}</span>
                                                                <input type="text" 
                                                                    placeholder="Search" 
                                                                    value={endpointSearch} 
                                                                    onChange={(e)=>{
                                                                        setEndpointSearch(e.target.value)
                                                                    }}
                                                                    onFocus={() => setEndpointSearchFocused(true)}
                                                                    onBlur={() => setEndpointSearchFocused(false)}
                                                                />
                                                                <button className="search-btn" onClick={onSearch}>Search</button>
                                                            </div>                                                            
                                                        </div>                                                        
                                                        <EndpointsFilter endPointFilterApply={endPointFilterApply} endpointFiltersValue={endpointFiltersValue} currentPage={"default"} />
                                                        {isAnyEndpointFilterActive && (<span className="reset-filter-link" onClick={resetEndpointFilterValue}>Reset Filter</span>)}
                                                    </div>
                                                    <div className="js-secrets-table">
                                                        {
                                                            isEndpointLoading || isLoading ?
                                                            <SkeletonLoader type={"line"} count={5} currentPage={"jsSecrets"} />
                                                            :
                                                            <Table>
                                                                <thead>
                                                                    <tr>
                                                                        <th>URL</th>
                                                                        <th>Extracted Data</th>
                                                                        <th>Status</th>
                                                                        <th>Retest</th>
                                                                        <th></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        jsSecretsEndpointsListResponse?.results?.length > 0 &&
                                                                        jsSecretsEndpointsListResponse?.results.map((data, index)=>{
                                                                            return (
                                                                                <motion.tr
                                                                                    key={index}
                                                                                    initial={{ opacity: 0, y: 20 }}
                                                                                    animate={{ opacity: 1, y: 0 }}
                                                                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                                                                >
                                                                                    <td className="url-container">
                                                                                        <a href={data?.url} target="_blank" className="table-url" rel="noreferrer">{data?.url}</a>
                                                                                        {data?.false_positive && <p className="false-positive">False Positive</p>}
                                                                                        {data?.new_record && <p><p className="d-inline-block new-data my-2">New</p></p>}
                                                                                    </td>
                                                                                    <td className="extraction-container">
                                                                                        {data?.extracted_data !== null && data?.extracted_data !== "" ? <p className="cursor-pointer" onClick={()=>{
                                                                                            setShowExtractDataModal(true)
                                                                                            setExtractedData(data?.extracted_data);
                                                                                        }}>view</p>: "-"}
                                                                                    </td>
                                                                                    <td className="status-container">
                                                                                        {data?.status === "closed" && <p className="status-close">Closed</p>}
                                                                                        {data?.status === "open" && <p className="status-open">Open</p>}
                                                                                        {data?.status === "wont_fix" && <p className="status-warn">Won't Fix</p>}
                                                                                    </td>
                                                                                    <td className="retest-summary">
                                                                                        <div className="finding-list">
                                                                                            <ul type="none" className="m-0 p-0">
                                                                                                <li className="d-flex justify-content-between gap-3">
                                                                                                    <span>Status: </span>
                                                                                                    {data?.retest?.status === "pending" && 
                                                                                                        <span className="retest-status pending">{data?.retest?.status}</span>
                                                                                                    }
                                                                                                    {data?.retest?.status === "in_progress" && 
                                                                                                        <span className="retest-status inprogress"> In Progress</span>
                                                                                                    }
                                                                                                    {data?.retest?.status === "completed" && 
                                                                                                        <span className="retest-status completed">{data?.retest?.status}</span>                                                                    
                                                                                                    }
                                                                                                    {data?.retest?.status === "failed" && 
                                                                                                        <span className="retest-status failed">Failed
                                                                                                            {data?.retest?.summary !== null && <CustomToolTip content={data?.retest?.summary } position={"top"}>
                                                                                                                <span className="info-icon">{infoBlueIcon()}</span>
                                                                                                            </CustomToolTip>}
                                                                                                        </span>
                                                                                                    }
                                                                                                    {data?.retest?.status === "stopped" && 
                                                                                                        <span className="retest-status stopped">{data?.retest?.status}</span>
                                                                                                    }
                                                                                                    {
                                                                                                        (data?.retest?.status === "" || data?.retest?.status === null) && <span>-</span>
                                                                                                    }
                                                                                                </li>
                                                                                                <li className="d-flex justify-content-between gap-3">
                                                                                                    <span>Fixed: </span>
                                                                                                    <span className="retest-status">{
                                                                                                        (data?.retest?.is_fixed !== null && data?.retest?.is_fixed !== "") 
                                                                                                        ? data?.retest?.is_fixed ? "Yes" : "No" : "-"}
                                                                                                        {data?.retest?.summary !== null && data?.retest?.status !== "failed" && <CustomToolTip content={data?.retest?.summary } position={"top"}>
                                                                                                            <span className="info-icon">{infoBlueIcon()}</span>
                                                                                                        </CustomToolTip>}
                                                                                                    </span>
                                                                                                </li>
                                                                                            </ul>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div className="view-more-div position-relative">
                                                                                            <span onClick={()=>{
                                                                                                setSelectedData(data)
                                                                                                setShowViewMore(true)
                                                                                            }}>{viewMoreIcon()}</span>
                                                                                            {showViewMore && data.id === selectedData.id && <div className="more-option-container position-absolute" ref={viewMoreWrapperRef}>                                                            
                                                                                                {getloggedInUserType() === "internal" && <p onClick={()=>{
                                                                                                    setModalType("valid")
                                                                                                    setSelectedValid(data?.false_positive ? "falsePositive" : "valid")                                                             
                                                                                                    setShowActionModal(true)
                                                                                                }}>Validate</p>}
                                                                                                <p onClick={()=>{
                                                                                                    setModalType("delete")                                                                
                                                                                                    setShowActionModal(true)
                                                                                                }}>Delete</p>
                                                                                                <p onClick={()=>{
                                                                                                    setModalType("updateStatus")
                                                                                                    setSelectedStatus(data?.status)                                                                                                                               
                                                                                                    setShowActionModal(true)
                                                                                                }}>Update Status</p>
                                                                                                {getloggedInUserType() === "internal" && <p onClick={()=>{
                                                                                                    setModalType("updateSeverity")
                                                                                                    setSelectedSeverity(data?.severity)
                                                                                                    setShowActionModal(true)
                                                                                                }}>Update Severity</p>}
                                                                                                {data?.retest?.status !== "in_progress" && data?.retest?.status !== "pending" ? <p onClick={()=>{
                                                                                                        setModalType("start")
                                                                                                        setShowActionModal(true)
                                                                                                    }}>Start - Retest</p> 
                                                                                                    :
                                                                                                    <p onClick={()=>{
                                                                                                        setModalType("stop")
                                                                                                        setShowActionModal(true)
                                                                                                    }}>Stop - Retest</p>
                                                                                                }
                                                                                            </div>}
                                                                                        </div>
                                                                                    </td>
                                                                                </motion.tr>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </Table>
                                                        }
                                                        {
                                                            !isEndpointLoading && jsSecretsEndpointsListResponse !== "" && jsSecretsEndpointsListResponse?.results.length === 0 && 
                                                            <motion.div
                                                                initial={{ opacity: 0, y: 20 }}
                                                                animate={{ opacity: 1, y: 0 }}
                                                                transition={{ duration: 0.4 }}
                                                            >
                                                                <NoDataFound noDataText={"No Record Found"}/>
                                                            </motion.div>
                                                        }
                                                        {jsSecretsEndpointsListResponse !== "" && jsSecretsEndpointsListResponse?.results?.length > 0 && <Pagination
                                                            className="pagination-bar"
                                                            currentPage={currentPage}
                                                            pageSize={currentPageSize}
                                                            totalCount={jsSecretsEndpointsListResponse?.meta?.total_results}
                                                            onPageChange={setCurrentPageandRecordSize}
                                                        />}                                                    
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>
                                    </>
                                )
                            }
                            
                        </div>
                    </Col>
                </Row>
                <Modal
                    show={showExtractDataModal}
                    onHide={()=>setShowExtractDataModal(false)}
                    size="md"
                    centered
                    className=""
                    >
                        <Modal.Body>
                            <div className="delete-organization-container">
                                <h4>Extracted Data</h4>
                                <div className="p-4 m-2">
                                    <p>{extractedData}</p>
                                </div>
                                <div className="d-flex justify-content-center gap-3 m-2">
                                    <div className="w-50">
                                        <Button buttonText="Close" buttonType={"secondary"} buttonClicked={()=>setShowExtractDataModal(false)}/>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                </Modal>
                <Modal
                    show={showActionModal}
                    onHide={() => setShowActionModal(false)}
                    size="md"
                    centered
                    >
                        {modalType === "delete" && <Modal.Body>
                            <div className="delete-organization-container">
                                <h4>Delete</h4>
                                <div className="organization-related-details p-4 m-2">
                                    <p>Are you sure, want to delete?</p>                                    
                                </div>
                                <div className="delete-organization-btn d-flex gap-3 m-2">
                                    <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                    {!modalLoading && <Button buttonText="Delete" buttonType={"primary"} buttonClicked={() => confirmDelete()} />}
                                    {modalLoading && <Button buttonText="Loading..." disableButton={true} buttonType={"secondary"} />}
                                </div>
                            </div>
                        </Modal.Body>}
                        {modalType === "valid" && <Modal.Body>
                            <div className="delete-organization-container">
                                <h4>Validate</h4>
                                <div className="organization-related-details p-4 m-2">
                                    <p className="mb-4">Please Select below option</p>
                                    <div className="filter-user-status d-flex mb-4 gap-4">
                                        <RadioButton radioId={1} radioValue={"valid"} radioLabel={"Valid"} onChange={(data)=>{setSelectedValid(data)}} isChecked={selectedValid === "valid"} />
                                        <RadioButton radioId={2} radioValue={"falsePositive"} radioLabel={"False Positive"} onChange={(data)=>{setSelectedValid(data)}} isChecked={selectedValid === "falsePositive"} />
                                    </div>
                                </div>
                                <div className="d-flex gap-3 m-2">
                                    <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                    {!modalLoading && <Button buttonText="Save" buttonType={"primary"} disableButton={selectedValid === ""} buttonClicked={() => saveUpdate()} />}
                                    {modalLoading && <Button buttonText="Loading..." buttonType={"primary"} disableButton={true} />}
                                </div>
                            </div>
                        </Modal.Body>}
                        {modalType === "updateStatus" && <Modal.Body>
                            <div className="delete-organization-container">
                                <h4>Update Status</h4>
                                <div className="organization-related-details p-4 m-2">
                                    <p className="mb-4">Please Select below option</p>
                                    <div className="filter-user-status d-flex mb-4 gap-4">
                                        <RadioButton radioId={1} radioValue={"open"} radioLabel={"Open"} onChange={(data)=>{setSelectedStatus(data)}} isChecked={selectedStatus === "open"} />
                                        <RadioButton radioId={2} radioValue={"closed"} radioLabel={"Close"} onChange={(data)=>{setSelectedStatus(data)}} isChecked={selectedStatus === "closed"} />
                                        <RadioButton radioId={3} radioValue={"wont_fix"} radioLabel={"won't Fix"} onChange={(data)=>{setSelectedStatus(data)}} isChecked={selectedStatus === "wont_fix"} />
                                    </div>
                                    {(selectedStatus === "closed" || selectedStatus === "wont_fix") && 
                                        <>
                                            <p className="mb-4">Comments</p>
                                            <textarea className="status-comments w-100" placeholder="Comments"></textarea>
                                        </>
                                    }
                                </div>
                                <div className="d-flex gap-3 m-2">
                                    <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                    {!modalLoading && <Button buttonText="Save" buttonType={"primary"} disableButton={selectedStatus === ""} buttonClicked={() => updateStatus()} />}
                                    {modalLoading && <Button buttonText="Loading..." buttonType={"primary"} disableButton={true} />}
                                </div>
                            </div>
                        </Modal.Body>}
                        {modalType === "updateSeverity" && <Modal.Body>
                            <div className="delete-organization-container">
                                <h4>Update Severity</h4>
                                <div className="organization-related-details p-4 m-2">
                                    <p className="mb-4">Please Select below option</p>
                                    <div className="update-severity-option d-flex mb-4">
                                        <RadioButton radioId={1} radioValue={"critical"} radioLabel={"Critical"} onChange={(data)=>{setSelectedSeverity(data)}} isChecked={selectedSeverity === "critical"} />
                                        <RadioButton radioId={2} radioValue={"high"} radioLabel={"High"} onChange={(data)=>{setSelectedSeverity(data)}} isChecked={selectedSeverity === "high"} />
                                        <RadioButton radioId={3} radioValue={"medium"} radioLabel={"Medium"} onChange={(data)=>{setSelectedSeverity(data)}} isChecked={selectedSeverity === "medium"} />
                                    </div>
                                    <div className="update-severity-option d-flex mb-4">
                                        <RadioButton radioId={4} radioValue={"low"} radioLabel={"Low"} onChange={(data)=>{setSelectedSeverity(data)}} isChecked={selectedSeverity === "low"} />
                                        <RadioButton radioId={5} radioValue={"informational"} radioLabel={"Informational"} onChange={(data)=>{setSelectedSeverity(data)}} isChecked={selectedSeverity === "informational"} />
                                    </div>
                                </div>
                                <div className="d-flex gap-3 m-2">
                                    <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                    {!modalLoading && <Button buttonText="Save" buttonType={"primary"} disableButton={selectedSeverity === ""} buttonClicked={() => updateSeverity()} />}
                                    {modalLoading && <Button buttonText="Loading..." buttonType={"primary"} disableButton={true} />}
                                </div>
                            </div>
                        </Modal.Body>}
                        {(modalType === "start" ||  modalType === "stop") && <Modal.Body>
                            <div className="delete-organization-container">
                                <h4>Update Retest</h4>
                                <div className="organization-related-details p-4 m-2">
                                    {modalType === "start" && <p className="mb-4">Are you want to start retest?</p>}                                   
                                    {modalType === "stop" && <p className="mb-4">Are you want to stop retest?</p>}                                  
                                </div>
                                <div className="d-flex gap-3 m-2">
                                    <Button buttonText="Cancel" buttonType={"secondary"} buttonClicked={() => setShowActionModal(false)}/>
                                    {!modalLoading && <Button buttonText="Save" buttonType={"primary"} buttonClicked={() => updateRetest()} />}
                                    {modalLoading && <Button buttonText="Loading..." buttonType={"primary"} disableButton={true} />}
                                </div>
                            </div>
                        </Modal.Body>}
                </Modal>
            </div>
        </>
        
    )
}


export default JSSecrets;